<section class="content profile-page">
  <div class="block-header">
      <div class="">
          <div class="row ">
              <div class="col-md-12  p-0">
                  <h2 class="poppins font-weight-bold pl-2">CustomerVirtualAccount</h2>
              </div>
              <div class=" col-md-5 px-6 col-sm-12 p-0">
                  <div class="breadcrumb flat">
                      <a [routerLink]="['/home']">Home</a>
                      <a href="#" class="active">New Customer VirtualAccount Info</a>
                  </div>
              </div>
              <div class="col-md-7">
                  <div class="float-right">  
                     
                      <button class="box-button mr-3" [routerLink]="['/PayOut/ManageVirtualAccount']">Virtual Account Info</button>
                     
                      <button [routerLink]="['/reports/transactions/summary']" class="box-button mr-3">Reports</button>
                       

                  </div>
              </div>
          </div>
      </div>

  </div>
  <div class="  ">
      <div class="row">
          <div class="col-md-12 p-0">
              <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                  <div class="row mx-0">
                      <div class="col-md-12">
                          <h4 class="font-weight-bold">Add Customer VirtualAccount Info</h4>
                      </div>

                  </div>
                  <div class="row mx-0">
                      <div class="col-md-7">
                          <div>
                              <form>
                                  <div class="form-group p-2">
                                      <div class="row pt-2">

                                          <div class="col-lg-4 col-md-5">
                                              <label for="sel1">Payout Customer keyId<span
                                                      class="text-danger">*</span></label>
                                          </div>
                                            
                                            <div class="col-lg-6  col-md-6">
                                              <div class="filter-input">
                                              <input type="text" placeholder="Payout Customer keyId" id="PayoutCustomerAccountKeyId" name="PayoutCustomerAccountKeyId" [formControl]="PayoutCustomerAccountKeyId"  (change)=onChange()   [(ngModel)]="Acckeyid" readonly>
                                              </div>
                                              <span class="text-danger" *ngIf="PayoutCustomerAccountKeyId.invalid && (PayoutCustomerAccountKeyId.dirty || PayoutCustomerAccountKeyId.touched)">{{PayoutCustomerAccountKeyIderrors()}}</span>
                                              
                                             <span class="text-danger" *ngIf="CustomerAccountkeyID">Invalid Payout Customer  KeyId</span>
                                            </div>
                                      </div>
                                      <!-- <div class="row pt-2">

                                        <div class="col-lg-4 col-md-5">
                                            <label for="sel1">Payout Customer keyId<span
                                                    class="text-danger">*</span></label>
                                        </div>
                                          
                                          <div class="col-lg-6  col-md-6">
                                            <div class="filter-input">
                                            <input type="text" placeholder="Payout Customer keyId" id="PayoutCustomerkeyId" name="PayoutCustomerkeyId"  [formControl]="PayoutCustomerkeyId">
                                            </div>
                                            <span class="text-danger" *ngIf="PayoutCustomerkeyId.invalid && (PayoutCustomerkeyId.dirty || PayoutCustomerkeyId.touched)">{{PayoutCustomerkeyIderrors()}}</span>
                                        </div>
                                    </div> -->

                                    <div class="row pt-2">

                                      <div class="col-lg-4 col-md-5">
                                          <label for="sel1">BankCode Type<span
                                                  class="text-danger">*</span></label>
                                      </div>
                                        
                                        <div class="col-lg-6  col-md-6">
                                          <div class="filter-input">
                                          <!-- <input type="text" placeholder="BankCode Type" id="BankCodeType" name="BankCodeType" [formControl]="BankCodeType"> -->
                                          <ngx-select [items]="Type" id="BankCodeType" placeholder="BankCode Type" name="BankCodeType" [formControl]="BankCodeType"  required></ngx-select>
                                          </div>
                                          <span class="text-danger" *ngIf="BankCodeType.invalid && (BankCodeType.dirty || BankCodeType.touched)">{{BankCodeTypeerrors()}}</span>
                                      </div>
                                  </div>
                                    
                                 
                                

                                <div class="row pt-2">

                                  <div class="col-lg-4 col-md-5">
                                      <label for="sel1">Account No<span
                                              class="text-danger">*</span></label>
                                  </div>
                                    
                                    <div class="col-lg-6  col-md-6">
                                      <div class="filter-input">
                                      <input type="text" placeholder="Account No" id="AccountNo" name="AccountNo" [formControl]="AccountNo" maxlength="17" minlength="9"  (blur)="checkaccnumber()">
                                      </div>
                                      <span class="text-danger" *ngIf="AccountNo.invalid && (AccountNo.dirty || AccountNo.touched)">{{AccountNoerrors()}}</span>
                                  </div>
                              </div>



                            
                              <div class="row pt-2">

                                <div class="col-lg-4 col-md-5">
                                    <label for="sel1">Confirm Account Number<span
                                            class="text-danger">*</span></label>
                                </div>
                                  
                                  <div class="col-lg-6  col-md-6">
                                    <div class="filter-input">
                                    <input onpaste="return false"  type="text" placeholder="Confirm Account Number" id="ConfirmAccountNumber" name="ConfirmAccountNumber" [formControl]="ConfirmAccountNumber" maxlength="17" minlength="9" (blur)="checkaccnumber()">
                                    </div>
                                    <span class="text-danger" *ngIf="ConfirmAccountNumber.invalid && (ConfirmAccountNumber.dirty || ConfirmAccountNumber.touched)">{{ConfirmAccountnumbererrors()}}</span>
                                   <span class="text-danger" *ngIf="Editaccerrormessage">Account Number and Confirm Account Number should be same</span>
                                    
                                  </div>
                            </div>









                              <div class="row pt-2">

                                <div class="col-lg-4 col-md-5">
                                    <label for="sel1">Bank Code/IFSC Code<span
                                            class="text-danger">*</span></label>
                                </div>
                                  
                                  <div class="col-lg-6  col-md-6">
                                    <div class="filter-input">
                                    <input type="text" placeholder="Bank Code/IFSC Code" id="BankCode" name="BankCode" [formControl]="BankCode" maxlength="11" minlength="9">
                                    </div>
                                    <span class="text-danger" *ngIf="BankCode.invalid && (BankCode.dirty || BankCode.touched)">{{BankCodeerrors()}}</span>
                                  </div>
                             
                            </div>
                            <div class="row pt-2">

                              <div class="col-lg-4 col-md-5">
                                  <label for="sel1">Account HolderName<span
                                          class="text-danger">*</span></label>
                              </div>
                                
                                <div class="col-lg-6  col-md-6">
                                  <div class="filter-input">
                                  <input type="text" placeholder="Account HolderName" id="AccountHolderName" name="AccountHolderName" [formControl]="AccountHolderName">
                                  </div>
                                  <span class="text-danger" *ngIf="AccountHolderName.invalid && (AccountHolderName.dirty || AccountHolderName.touched)">{{AccountHolderNameerrors()}}</span>
                              </div>
                          </div>
                          <div class="row pt-2">

                            <div class="col-lg-4 col-md-5">
                                <label for="sel1">Address<span
                                        class="text-danger">*</span></label>
                            </div>
                              
                              <div class="col-lg-6  col-md-6">
                                <div class="filter-input">
                                <input type="text" placeholder="Address" id="Address" name="Address" [formControl]="Address">
                                </div>
                                <span class="text-danger" *ngIf="Address.invalid && (Address.dirty || Address.touched)">{{Addresserrors()}}</span>

                            </div>
                        </div>
                        <div class="row pt-2">

                          <div class="col-lg-4 col-md-5">
                              <label for="sel1">City<span
                                      class="text-danger">*</span></label>
                          </div>
                            
                            <div class="col-lg-6  col-md-6">
                              <div class="filter-input">
                              <input type="text" placeholder="City" id="City" name="City" [formControl]="City" [(ngModel)]="city">
                              </div>
                              <span class="text-danger" *ngIf="City.invalid && (City.dirty || City.touched)">{{Cityerrors()}}</span>
                          </div>
                      </div>
                      <div class="row pt-2">

                        <div class="col-lg-4 col-md-5">
                            <label for="sel1">State<span
                                    class="text-danger">*</span></label>
                        </div>
                          
                          <div class="col-lg-6  col-md-6">
                            <div class="filter-input">
                            <!-- <input type="text" placeholder="State" id="State" name="State" [formControl]="State"> -->
                            <ngx-select [items]="stateList" placeholder="State" id="State" name="State" [formControl]="State" [(ngModel)]="state">
                            </ngx-select>
                            </div>
                            <span class="text-danger" *ngIf="State.invalid && (State.dirty || State.touched)">{{Stateerrors()}}</span>
                        </div>
                    </div>
                    <div class="row pt-2">

                      <div class="col-lg-4 col-md-5">
                          <label for="sel1">ZipCode<span
                                  class="text-danger">*</span></label>
                      </div>
                        
                        <div class="col-lg-6  col-md-6">
                          <div class="filter-input">
                          <input type="text" placeholder="ZipCode" id="ZipCode" name="ZipCode"  [formControl]="ZipCode" maxlength="6"  (change)="Getzipcodedetails()" required>
                          </div>
                          <span class="text-danger" *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)">{{ZipCodeerrors()}}</span>
                      </div>
                  </div>
                  <div class="row pt-2">

                    <div class="col-lg-4 col-md-5">
                        <label for="sel1">MobileNo<span
                                class="text-danger">*</span></label>
                    </div>
                      
                      <div class="col-lg-6  col-md-6">
                        <div class="filter-input">
                        <input type="text" placeholder="MobileNo" id="MobileNo" name="MobileNo"  [formControl]="MobileNo" maxlength="10">
                        </div>
                        <span class="text-danger" *ngIf="MobileNo.invalid && (MobileNo.dirty || MobileNo.touched)">{{MobileNoeerrors()}}</span>
                    </div>
                </div>
                <div class="row pt-2">

                  <div class="col-lg-4 col-md-5">
                      <label for="sel1">MobileNotification<span
                              class="text-danger"></span></label>
                  </div>
                    
                    <div class="col-lg-6  col-md-6">
                      <div class="filter-input">
                      <!-- <input type="text" placeholder="MobileNotification" id="MobileNotification" name="MobileNotification"  [formControl]="MobileNotification"> -->
                      <ngx-select [items]="Notification" id="MobileNotification" placeholder="MobileNotification" name="MobileNotification" [formControl]="MobileNotification"  required></ngx-select>
                    </div>
                    
                  </div>
              </div>
            
            <div class="row pt-2">

              <div class="col-lg-4 col-md-5">
                  <label for="sel1">Email<span
                          class="text-danger">*</span></label>
              </div>
                
                <div class="col-lg-6  col-md-6">
                  <div class="filter-input">
                  <input type="text" placeholder="Email" id="Email" name="Email" [formControl]="Email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$">
                  </div>
                  <span class="text-danger" *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{Emaileerrors()}}</span>
              </div>
          </div>
          <div class="row pt-2">

            <div class="col-lg-4 col-md-5">
                <label for="sel1">EmailNotification<span
                        class="text-danger"></span></label>
            </div>
              
              <div class="col-lg-6  col-md-6">
                <div class="filter-input">
                <!-- <input type="text" placeholder="EmailNotification" id="EmailNotification" name="EmailNotification" [formControl]="EmailNotification">
                -->
                <ngx-select [items]="Notification" id="EmailNotification" placeholder="EmailNotification" name="EmailNotification" [formControl]="EmailNotification"  ></ngx-select>
              </div>
              
            </div>
        </div>
        <div class="row pt-2">

          <div class="col-lg-4 col-md-5">
              <label for="sel1">Payout Processor<span
                      class="text-danger"></span></label>
          </div>
            
            <div class="col-lg-6  col-md-6">
              <div class="filter-input">
              <input type="text" placeholder="Payout Processor" id="PayoutProcessor" name="PayoutProcessor"  [formControl]="PayoutProcessor">
              </div>
            
          </div>
      </div>  
      <div class="row pt-2">

        <div class="col-lg-4 col-md-5">
            <label for="sel1">Bank Reference Id<span
                    class="text-danger"></span></label>
        </div>
          
          <div class="col-lg-6  col-md-6">
            <div class="filter-input">
            <input type="text" placeholder="Bank Reference Id" id="BankRefereceId" name="BankRefereceId"  [formControl]="BankRefereceId">
            </div>
          
        </div>
    </div>  
            
                                      <div class="text-right pt-2">
                                         
                                          <button class="btn box-button px-4 py-2" 
                                            id="Savecoupon" color="primary"  (click)="Newvirtualinfo()"
                                            [disabled]="PayoutCustomerAccountKeyId.invalid || BankCodeType.invalid ||AccountNo.invalid|| Address.invalid || City.invalid || State.invalid || ZipCode.invalid || MobileNo.invalid || Email.invalid||Editaccerrormessage"
                                            >Proceed Now</button>
                                      </div>
                                    
                                   </div>
                              </form>
                          </div>



                        
                      </div>
                      <div class="col-md-5">
                          <div class="b">
                              <img src="assets/img/collecting-money.png" alt="Tips"
                                  style="display: block; width: 100%;">
                          </div>
                          
                      </div>



                   
              </div>
          </div>
      </div>
  </div>
  </div>
</section>




